import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Action } from './action';
import RenameCampaignIcon from '../../../../icons/rename-campaign.svg';
import styles from './styles.module.scss';
import { useToggle } from '../../../../../../../infra/small-tools/use-toggle';
// eslint-disable-next-line max-len
import { RenameCampaignModalContainer as RenameCampaignModal } from '../../../../../components/rename-campaign-modal/rename-campaign-modal.container';
import { refetchCampaignsListQuery } from '../../../../../network/utils';
export var RenameAction = function (_a) {
    var campaign = _a.campaign;
    var showRenameModal = useToggle(false);
    // Workaround to prevent the button action from the table row that redirects to the campaign edit/detail page
    var handleModalClick = function (e) {
        e.stopPropagation();
    };
    var handleSuccessUpdate = function () {
        refetchCampaignsListQuery();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Action, { name: "Rename", Icon: RenameCampaignIcon, onClick: showRenameModal.setOn, id: "rename-campaign-".concat(campaign.id), className: styles['action-button'] }), _jsx("button", { onClick: handleModalClick, className: styles['modal-wrapper-button'], children: showRenameModal.isOn && (_jsx(RenameCampaignModal, { campaign: campaign, onClose: showRenameModal.setOff, onSuccessUpdate: handleSuccessUpdate })) })] }));
};
